import { useSelector } from 'react-redux';

export default () => {
    return useSelector( state => {
        try{
            return state.slugInfo.components.hawksearchResults;
        }catch(e){}
    });
}